(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hj-button-motion"] && !Shopify.designMode) return;
  try {
    window.HJTransitionPrice=function(price,text,cents){
  const amount=price.querySelector('[data-price-amount]');
  if(!amount)return;
  const previous=Number(price.dataset.priceCents),next=Number(cents);
  const version=(price._priceVersion||0)+1;price._priceVersion=version;
  price.dataset.priceCents=String(next);
  price._priceAnimation?.cancel();
  if(previous===next||matchMedia('(prefers-reduced-motion: reduce)').matches){
    amount.textContent=text;return;
  }
  const direction=next>previous?-1:1;
  const animation=amount.animate([{transform:'translateX(0)',opacity:1},{transform:'translateX('+direction*32+'px)',opacity:0}],{duration:170,easing:'ease-in',fill:'forwards'});
  price._priceAnimation=animation;
  animation.finished.then(()=>{
    if(price._priceVersion!==version)return;
    animation.cancel();amount.textContent=text;
    price._priceAnimation=amount.animate([{transform:'translateX('+(-direction*32)+'px)',opacity:0},{transform:'translateX(0)',opacity:1}],{duration:240,easing:'cubic-bezier(.22,1,.36,1)'});
  }).catch(()=>{});
};

function initHJButtonMotion(scope){
  scope.querySelectorAll('.hj-tray__button,.hj-card__add,.hj-product-add,.hj-range__all,.hj-served__button,.hj-cart-page__button,.hj-cart__checkout,.hj-cart__continue').forEach(button=>{
    if(button.dataset.springReady)return;
    button.dataset.springReady='true';
    let animation=null;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    function move(enter){
      const current=getComputedStyle(button).transform;
      animation?.cancel();
      if(reduced.matches||(enter&&button.disabled))return;
      const group=button.closest('.hj-range__track')||document;
      const index=[...group.querySelectorAll('button.hj-card__add,.hj-product-add')].indexOf(button);
      const direction=index>=0&&index%2?-1:1;
      const frames=enter?[{transform:current},{transform:'rotate('+direction*2+'deg) scale(1.05)'}]:[{transform:current},{transform:'rotate('+(-direction)+'deg) scale(1.0125)',offset:.6},{transform:'rotate(0) scale(1)'}];
      animation=button.animate(frames,{duration:enter?360:430,easing:enter?'cubic-bezier(.34,1.56,.64,1)':'cubic-bezier(.45,0,.2,1)',fill:enter?'forwards':'none'});
    }
    button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')move(true)});
    button.addEventListener('pointerleave',()=>move(false));
    button.addEventListener('click',()=>move(false),{capture:true});
    button.addEventListener('pointercancel',()=>{animation?.cancel();animation=null});
    button.addEventListener('blur',()=>move(false));
    reduced.addEventListener('change',()=>{animation?.cancel();animation=null});
  });
}
initHJButtonMotion(document);
document.addEventListener('hj:content-updated',event=>initHJButtonMotion(event.detail.scope));
document.addEventListener('shopify:section:load',event=>initHJButtonMotion(event.target));

const hjSparkleTimes=new WeakMap();
function playHJSparkles(option,size){
  const big=size!=='15',count=size==='15'?8:size==='30'?18:10,strength=size==='150'?5:size==='75'?3.8:big?2.8:1;
  const particleSize=size==='150'?40:size==='75'?28:big?16:10;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const now=performance.now();
  if(now-(hjSparkleTimes.get(option)||-Infinity)<100)return;
  hjSparkleTimes.set(option,now);
  document.querySelectorAll('.hj-size-sparkle').forEach(item=>item.remove());
  const rect=option.getBoundingClientRect();
  const radius=Math.max(rect.width,rect.height)/2+3;
  for(let i=0;i<count;i++){
    const angle=i*Math.PI*2/count;
    const x=Math.cos(angle),y=Math.sin(angle);
    const particle=document.createElement('span');
    particle.className='hj-size-sparkle';
    particle.style.width=particleSize+'px';particle.style.height=particleSize+'px';
    particle.setAttribute('aria-hidden','true');
    particle.style.left=(rect.left+scrollX+rect.width/2+x*radius-(particleSize/2))+'px';
    particle.style.top=(rect.top+scrollY+rect.height/2+y*radius-(particleSize/2))+'px';
    particle.style.background=i%2?'#1f70ef':'#f20b67';
    document.body.append(particle);
    const animation=particle.animate([
      {transform:'translate(0,0) scale(.3) rotate(0deg)',opacity:0},
      {transform:'translate('+x*6*strength+'px,'+y*6*strength+'px) scale(1) rotate(30deg)',opacity:1,offset:.2},
      {transform:'translate('+x*22*strength+'px,'+y*22*strength+'px) scale(.1) rotate(90deg)',opacity:0}
    ],{duration:big?750:550,easing:'ease-out',fill:'forwards'});
    animation.finished.then(()=>particle.remove()).catch(()=>particle.remove());
    setTimeout(()=>particle.remove(),900);
  }
}
document.addEventListener('click',event=>{
  const option=event.target.closest('.hj-card__variant,.hj-product-variants label');
  if(!option)return;
  const size=option.querySelector('span')?.textContent.trim(),input=option.querySelector('input');
  if(!['15','30','75','150'].includes(size)||!input||input.disabled)return;
  playHJSparkles(option,size);
});
document.addEventListener('hj:tray-sparkles',event=>{
  if(event.detail?.target instanceof HTMLElement)playHJSparkles(event.detail.target,'30');
});

const hjSizeFxTimes=new WeakMap();
const hjSizeFxReduced=matchMedia('(prefers-reduced-motion: reduce)');
let hjSizeFxAnimations=[],hjSizeFxLayer=null,hjSizeFxTimer;
function clearHJSizeFx(){
  document.documentElement.classList.remove('hj-quake-active');
  hjSizeFxAnimations.forEach(animation=>animation.cancel());
  hjSizeFxAnimations=[];
  hjSizeFxLayer?.remove();hjSizeFxLayer=null;
  clearTimeout(hjSizeFxTimer);
}
function animateHJSizeFx(element,frames,options){
  const animation=element.animate(frames,options);
  hjSizeFxAnimations.push(animation);
  return animation;
}
function hjSizeFxNode(className,left,top){
  const node=document.createElement('span');
  node.className=className;
  node.style.left=left+'px';node.style.top=top+'px';
  hjSizeFxLayer.append(node);
  return node;
}
function playHJSizeFx(option,size,trayOnly=false){
  if(!option||hjSizeFxReduced.matches)return;
  const now=performance.now();
  if(now-(hjSizeFxTimes.get(option)??-Infinity)<100)return;
  hjSizeFxTimes.set(option,now);
  clearHJSizeFx();
  const rect=option.getBoundingClientRect(),cx=rect.left+rect.width/2,cy=rect.top+rect.height/2;
  hjSizeFxLayer=document.createElement('div');
  hjSizeFxLayer.className='hj-size-fx-layer';
  hjSizeFxLayer.setAttribute('aria-hidden','true');
  document.body.append(hjSizeFxLayer);
  {
    const diameter=2.9*Math.max(Math.hypot(cx,cy),Math.hypot(innerWidth-cx,cy),Math.hypot(cx,innerHeight-cy),Math.hypot(innerWidth-cx,innerHeight-cy));
    for(let wave=0;wave<(size==='150'?2:1);wave++){
    const rainbow=hjSizeFxNode('hj-size-rainbow',cx-diameter/2,cy-diameter/2);
    rainbow.style.width=diameter+'px';rainbow.style.height=diameter+'px';
    animateHJSizeFx(rainbow,[
      {transform:'scale(.015)',opacity:0},
      {transform:'scale(.12)',opacity:.8,offset:.15},
      {transform:'scale(.7)',opacity:.55,offset:.65},
      {transform:'scale(1)',opacity:0}
    ],{duration:1250,delay:wave*160,easing:'cubic-bezier(.2,.6,.35,1)',fill:'both'});
    }
  }
  if(size==='150'){
    document.documentElement.classList.add('hj-quake-active');
    const reach=Math.max(Math.hypot(cx,cy),Math.hypot(innerWidth-cx,cy),Math.hypot(cx,innerHeight-cy),Math.hypot(innerWidth-cx,innerHeight-cy))*1.08;
    const radius=Math.max(1000,Math.hypot(innerWidth,innerHeight));
    const selector='.hj-card__variant,.hj-product-variants label,.hj-card h3,.hj-card__image,.hj-card__review,.hj-card__price,.hj-card__variant-label,.hj-card__add,.hj-product-buy h1,.hj-product-rating,.hj-product-price,.hj-product-shipping,.hj-product-add,.hj-product-benefits li,.hj-product-main-image,.hj-product-copy h2,.hj-product-description,.hj-product-accordions summary,.hj-logo,.hj-pick,.hj-header .hj-icon,.hj-desktop-nav a,.hj-announcement,.hj-range h2,.hj-range__tab,.hj-range__all,.hj-vtray__intro h1,.hj-vtray__intro>p,.hj-vtray__stage,.hj-vtray__progress-heading,.hj-vtray__progress,.hj-vtray__choice,.hj-vtray__actions button,.hj-vtray__price,.hj-vtray__saving,.hj-vtray__pack-note,.hj-vtray__pack-summary,.hj-vtray__buy,.hj-vtray__delivery';
    const targets=[...(trayOnly ? option.closest('[data-hj-vtray]').querySelectorAll('.hj-vtray__stage,.hj-vtray__pot') : document.querySelectorAll(selector))].map(node=>({node,box:node.getBoundingClientRect()})).filter(({box})=>box.width&&box.height&&box.bottom>0&&box.top<innerHeight&&box.right>0&&box.left<innerWidth).map(item=>({...item,distance:Math.hypot(item.box.left+item.box.width/2-cx,item.box.top+item.box.height/2-cy)})).sort((a,b)=>a.distance-b.distance).slice(0,64);
    targets.forEach(({node,distance},index)=>{
      const force=Math.pow(Math.max(0,1-distance/radius),2);
      if(force<.02)return;
      const amplitude=7*force,angle=3*force;
      const frames=Array.from({length:11},(_,i)=>{
        const decay=i===0?0:Math.pow(1-i/10,1.5),sign=(i%2?1:-1)*(index%2?1:-1);
        return {translate:sign*amplitude*decay+'px '+-sign*amplitude*.45*decay+'px',rotate:sign*angle*decay+'deg',offset:i/10};
      });
      animateHJSizeFx(node,frames,{duration:800,delay:Math.min(distance/reach*1100,1100),easing:'ease-in-out'});
    });
    if(!trayOnly){
    const base=getComputedStyle(option);
    animateHJSizeFx(option,[{backgroundColor:base.backgroundColor,color:base.color},{backgroundColor:'#ef3232',color:'#fff',offset:.18},{backgroundColor:'#ef3232',color:'#fff',offset:.55},{backgroundColor:base.backgroundColor,color:base.color}],{duration:1000,easing:'ease-in-out'});
  }
  }
  hjSizeFxTimer=setTimeout(clearHJSizeFx,2000);
}
document.addEventListener('click',event=>{
  const option=event.target.closest('.hj-card__variant,.hj-product-variants label');
  if(!option)return;
  const size=option.querySelector('span')?.textContent.trim(),input=option.querySelector('input');
  if(!['75','150'].includes(size)||!input||input.disabled)return;
  playHJSizeFx(option,size);
});
document.addEventListener('hj:rainbow-burst',event=>{
  const target=event.detail?.target;
  if(target instanceof HTMLElement)playHJSizeFx(target,event.detail.quake?'150':'75',Boolean(event.detail.quake));
});
hjSizeFxReduced.addEventListener('change',clearHJSizeFx);
window.addEventListener('scroll',clearHJSizeFx,{passive:true,capture:true});
document.addEventListener('visibilitychange',()=>{if(document.hidden)clearHJSizeFx()});
document.addEventListener('shopify:section:unload',clearHJSizeFx);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hj-cart-drawer"] && !Shopify.designMode) return;
  try {
    function initHJCart(section){if(window.HJCart)return;const root=section.querySelector('[data-hj-cart]');if(!root)return;const drawer=root.querySelector('.hj-cart__drawer'),items=root.querySelector('[data-cart-items]'),empty=root.querySelector('[data-cart-empty]'),total=root.querySelector('[data-cart-total]'),checkout=root.querySelector('.hj-cart__checkout'),moneyFormat=section.dataset.moneyFormat||'£AMOUNT',amountToken='{'+'{amount}'+'}',noDecimalsToken='{'+'{amount_no_decimals}'+'}';let lastFocus;const money=cents=>moneyFormat.replace(amountToken,(cents/100).toFixed(2)).replace(noDecimalsToken,Math.round(cents/100));const escapeHTML=value=>String(value||'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));const detailStrings=JSON.parse(section.querySelector('[data-cart-detail-strings]').textContent);
function renderDetails(item){
 const properties=item.properties||{},raw=properties['Flavour selection'];
 const eligible=item.handle==='custom-tray'||properties._hj_mix_basis==='per_tray';
 const shots=Number(String(item.variant_title||'').match(/^([0-9]+)\s+shots?\b/i)?.[1]);
 const parsed=typeof raw==='string'?raw.split(',').map(part=>part.trim().match(/^(.+):\s*(\d+)$/)):[];
 const valid=eligible && [15,30,75,150].includes(shots) && parsed.length>0 && parsed.every(Boolean) && parsed.reduce((sum,part)=>sum+Number(part?.[2]||0),0)===15;
 const trays=shots/15 * item.quantity;
 let html='';
 if(valid){
  html='<div class="hj-cart-mix"><strong>'+escapeHTML(detailStrings.mix)+'</strong><p class="hj-cart-mix__note">'+escapeHTML(detailStrings.mix_note.replace('[count]',trays))+'</p><ul>'+parsed.map(part=>'<li><span>'+escapeHTML(part[1])+'</span><span><strong>'+escapeHTML(detailStrings.total.replace('[count]',Number(part[2])*trays))+'</strong><small>'+escapeHTML(detailStrings.per_tray.replace('[count]',part[2]))+'</small></span></li>').join('')+'</ul></div>';
 }
 const gift=properties['Send as a gift']==='Yes'||Boolean(properties['Gift message']);
 if(gift){
  html+='<div class="hj-cart-gift"><strong>'+escapeHTML(detailStrings.gift)+'</strong>';
  for(const [key,label] of [['Gift to',detailStrings.to],['Gift from',detailStrings.from]])if(properties[key])html+='<p>'+escapeHTML(label)+': '+escapeHTML(properties[key])+'</p>';
  if(properties['Gift message'])html+='<p class="hj-cart-gift__message">'+escapeHTML(properties['Gift message'])+'</p>';
  html+='</div>';
 }
 html+=Object.entries(properties).filter(([key,value])=>!key.startsWith('_')&&value&&!(valid&&key==='Flavour selection')&&!(gift&&['Send as a gift','Gift to','Gift from','Gift message'].includes(key))).map(([key,value])=>'<p class="hj-cart__item-variant">'+escapeHTML(key)+': '+escapeHTML(value)+'</p>').join('');
 return html;
}
function updateCount(count){document.querySelectorAll('.hj-cart-link').forEach(link=>{let badge=link.querySelector('.hj-count');if(count>0&&!badge){badge=document.createElement('span');badge.className='hj-count';link.append(badge)}if(badge){badge.textContent=count;if(!count)badge.remove()}})}function render(cart){items.innerHTML=cart.items.map(item=>`<article class="hj-cart__item" data-cart-key="${escapeHTML(item.key)}"><img class="hj-cart__item-image" src="${escapeHTML(item.image||'')}" alt="${escapeHTML(item.product_title)}"><div><h3 class="hj-cart__item-title">${escapeHTML(item.product_title)}</h3><p class="hj-cart__item-variant">${escapeHTML(item.variant_title==='Default Title'?'':item.variant_title)}</p>${renderDetails(item)}<div class="hj-cart__quantity"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-cart-quantity="${item.quantity-1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escapeHTML(item.key)}" data-cart-quantity="${item.quantity+1}" aria-label="Increase quantity">+</button></div></div><strong class="hj-cart__item-price">${money(item.final_line_price)}</strong></article>`).join('');empty.hidden=cart.item_count>0;items.hidden=cart.item_count===0;total.textContent=money(cart.total_price);checkout.hidden=cart.item_count===0;updateCount(cart.item_count)}async function getCart(){const response=await fetch('/cart.js',{headers:{Accept:'application/json'}});if(!response.ok)throw new Error();const cart=await response.json();render(cart);return cart}async function changeItem(key,quantity){const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});if(!response.ok)throw new Error();render(await response.json())}function open(){lastFocus=document.activeElement;root.hidden=false;requestAnimationFrame(()=>root.classList.add('is-open'));drawer.focus();getCart().catch(()=>{})}function close(){root.classList.remove('is-open');setTimeout(()=>{root.hidden=true;lastFocus?.focus()},430)}root.querySelectorAll('[data-cart-close]').forEach(button=>button.addEventListener('click',close));root.addEventListener('click',event=>{const button=event.target.closest('[data-cart-change]');if(button)changeItem(button.dataset.cartChange,Number(button.dataset.cartQuantity)).catch(()=>getCart())});document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!root.hidden)close()});document.querySelectorAll('.hj-cart-link').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();open()}));window.HJCart={open,getCart,render};}
function initHJSharedCarts(){document.querySelectorAll('[data-hj-cart-host]').forEach(initHJCart)}initHJSharedCarts();document.addEventListener('shopify:section:load',initHJSharedCarts);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hj-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function(){
  const key='hj-bank-holidays-v1';
  let holidays;
  const dateKey=date=>date.toISOString().slice(0,10);
  function today(){
    const parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const get=type=>parts.find(part=>part.type===type).value;
    return new Date(get('year')+'-'+get('month')+'-'+get('day')+'T12:00:00Z');
  }
  function advance(start,count,dispatch){
    const date=new Date(start);
    while(count>0){
      date.setUTCDate(date.getUTCDate()+1);
      const day=date.getUTCDay();
      if(day!==0&&(!dispatch||day!==6)&&!holidays.has(dateKey(date)))count--;
    }
    return date;
  }
  const format=date=>new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',day:'numeric',month:'short'}).format(date);
  function range(start,end){
    return start.getUTCMonth()===end.getUTCMonth()&&start.getUTCFullYear()===end.getUTCFullYear()?start.getUTCDate()+'–'+format(end):format(start)+'–'+format(end);
  }
  function render(){
    if(!holidays)return;
    const dispatch=advance(today(),1,true);
    const standard=range(advance(dispatch,2,false),advance(dispatch,3,false));
    const express=range(advance(dispatch,1,false),advance(dispatch,2,false));
    document.querySelectorAll('[data-delivery-estimate]').forEach(root=>{
      root.querySelector('[data-delivery-standard]').textContent=standard;
      root.querySelector('[data-delivery-express]').textContent=express;
    });
  }
  function accept(data){
    const events=data?.['england-and-wales']?.events;
    if(!Array.isArray(events)||!events.length)return false;
    const dates=events.map(event=>event.date);
    const horizon=today();horizon.setUTCDate(horizon.getUTCDate()+21);
    if(dates.slice().sort().at(-1)<dateKey(horizon))return false;
    holidays=new Set(dates);render();return true;
  }
  try{
    const cached=JSON.parse(sessionStorage.getItem(key)||'null');
    if(cached&&Date.now()-cached.saved<86400000)accept(cached.data);
  }catch{}
  if(!holidays){
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),5000);
    fetch('https://www.gov.uk/bank-holidays.json',{signal:controller.signal})
      .then(response=>{if(!response.ok)throw Error();return response.json()})
      .then(data=>{if(accept(data)){try{sessionStorage.setItem(key,JSON.stringify({saved:Date.now(),data}))}catch{}}})
      .catch(()=>{}).finally(()=>clearTimeout(timeout));
  }
  document.addEventListener('shopify:section:load',render);
  document.addEventListener('hj:content-updated',render);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)render()});
  setInterval(render,60000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hj-gift-note"] && !Shopify.designMode) return;
  try {
    function initHJGiftNotes(scope){
  scope.querySelectorAll('[data-hj-gift]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='true';
    const toggle=root.dataset.toggleId?document.getElementById(root.dataset.toggleId):root.querySelector('[data-gift-toggle]'),fields=root.querySelector('[data-gift-fields]'),message=root.querySelector('[data-gift-message]'),count=root.querySelector('[data-gift-count]');
    const toggleCopy=toggle.closest('label').querySelector('span');
    const originalCopy=toggleCopy.textContent;
    let lastChecked=toggle.checked,copyAnimation=null,copyVersion=0;
    function updateCopy(){
      if(!root.dataset.toggleId||lastChecked===toggle.checked)return;
      lastChecked=toggle.checked;
    const text=toggle.checked?"great, free gift note unlocked":originalCopy;
      const direction=toggle.checked?-1:1,version=++copyVersion;
      copyAnimation?.cancel();
      if(matchMedia('(prefers-reduced-motion: reduce)').matches){toggleCopy.textContent=text;return;}
      copyAnimation=toggleCopy.animate([{transform:'translateX(0)',opacity:1},{transform:'translateX('+direction*32+'px)',opacity:0}],{duration:170,easing:'ease-in',fill:'forwards'});
      copyAnimation.finished.then(()=>{
        if(version!==copyVersion)return;
        copyAnimation.cancel();toggleCopy.textContent=text;
        copyAnimation=toggleCopy.animate([{transform:'translateX('+(-direction*32)+'px)',opacity:0},{transform:'translateX(0)',opacity:1}],{duration:240,easing:'cubic-bezier(.22,1,.36,1)'});
      }).catch(()=>{});
    }
    let panelOpen=null,panelAnimation=null,panelVersion=0;
    function revealPanel(open){
      if(panelOpen===open)return;
      const initial=panelOpen===null;panelOpen=open;
      const panel=root.dataset.toggleId?root:fields;
      const before=getComputedStyle(panel);
      const start={height:panel.getBoundingClientRect().height+'px',opacity:before.opacity,marginTop:before.marginTop,marginBottom:before.marginBottom,paddingTop:before.paddingTop,paddingBottom:before.paddingBottom,borderTopWidth:before.borderTopWidth,borderBottomWidth:before.borderBottomWidth};
      const wasHidden=panel.hidden;
      panelAnimation?.cancel();const version=++panelVersion;
      panel.hidden=false;fields.hidden=false;
      if(initial||matchMedia('(prefers-reduced-motion: reduce)').matches){
        panel.hidden=!open;fields.hidden=!open;return;
      }
      const natural=getComputedStyle(panel);
      const expanded={height:panel.getBoundingClientRect().height+'px',opacity:1,marginTop:natural.marginTop,marginBottom:natural.marginBottom,paddingTop:natural.paddingTop,paddingBottom:natural.paddingBottom,borderTopWidth:natural.borderTopWidth,borderBottomWidth:natural.borderBottomWidth};
      const collapsed={height:'0px',opacity:0,marginTop:'0px',marginBottom:'0px',paddingTop:'0px',paddingBottom:'0px',borderTopWidth:'0px',borderBottomWidth:'0px'};
      panel.style.overflow='hidden';
      panelAnimation=panel.animate([wasHidden?collapsed:start,open?expanded:collapsed],{duration:360,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
      panelAnimation.finished.then(()=>{
        if(version!==panelVersion)return;
        panel.hidden=!open;fields.hidden=!open;
        panelAnimation.cancel();panel.style.overflow='';
      }).catch(()=>{});
    }
    function update(){
      updateCopy();
      revealPanel(toggle.checked);
      toggle.setAttribute('aria-expanded',String(toggle.checked));
      fields.querySelectorAll('input,textarea').forEach(input=>input.disabled=!toggle.checked);
      message.required=toggle.checked;
      message.setCustomValidity(toggle.checked&&!message.value.trim()?message.dataset.requiredText:'');
      count.textContent=String(message.value.length);
    }
    toggle.addEventListener('change',update);message.addEventListener('input',update);update();
  });
}
initHJGiftNotes(document);
document.addEventListener('shopify:section:load',event=>initHJGiftNotes(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hj-review-overlay"] && !Shopify.designMode) return;
  try {
    (()=>{
  if(window.self!==window.top)return;
  const dialog=document.querySelector('[data-review-overlay]');
  if(!dialog||typeof dialog.showModal!=='function')return;
  const frame=dialog.querySelector('[data-review-frame]'),close=dialog.querySelector('[data-review-close]'),loading=dialog.querySelector('[data-review-loading]'),fallback=dialog.querySelector('[data-review-fallback]');
  let trigger=null,overflow='',timer,request=0;
  async function loadReviews(url){
    const current=++request;
    frame.hidden=true;loading.hidden=false;fallback.hidden=true;fallback.href=url.href;
    try{
      const response=await fetch(url.href,{credentials:'same-origin'});
      if(!response.ok)throw new Error('Reviews unavailable');
      const html=await response.text();
      if(current!==request||!dialog.open)return;
      const doc=new DOMParser().parseFromString(html,'text/html');
      const base=doc.createElement('base');base.href=url.href;doc.head.prepend(base);
      frame.srcdoc='<!doctype html>'+doc.documentElement.outerHTML;
    }catch(error){if(current===request){loading.hidden=true;fallback.hidden=false;}}
  }
  function reviewURL(href){
    try{
      const url=new URL(href,location.href);
      return url.origin===location.origin&&/\/pages\/(product-reviews|leave-a-review)\/?$/.test(url.pathname)?url:null;
    }catch(error){return null;}
  }
  function openReviews(url,link){
    trigger=link;fallback.href=url.href;fallback.hidden=true;loading.hidden=false;frame.hidden=true;
    overflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden';
    dialog.showModal();close.focus();
    loadReviews(url);
    clearTimeout(timer);timer=setTimeout(()=>{if(dialog.open)fallback.hidden=false;},15000);
  }
  function dismiss(){if(dialog.open)dialog.close();}
  close.addEventListener('click',dismiss);
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dismiss();}});
  dialog.addEventListener('close',()=>{
    clearTimeout(timer);document.documentElement.style.overflow=overflow;
    request++;frame.removeAttribute('srcdoc');frame.hidden=true;trigger?.focus();
  });
  frame.addEventListener('load',()=>{
    if(!dialog.open)return;
    try{
      const doc=frame.contentDocument;
      if(!doc?.querySelector('#MainContent'))return;
      const style=doc.createElement('style');
      style.textContent='body> :not(main){display:none!important}html,body{margin:0!important;padding:0!important;overflow-x:hidden}main{display:block!important;padding:0!important;margin:0!important}.hj-all-reviews{padding:14px 16px 20px!important;min-height:0}.hj-all-reviews__back,.hj-all-reviews__eyebrow{display:none!important}.hj-all-reviews h1{display:block!important;font-size:20px!important;line-height:1.25!important;margin:0 0 10px!important}.hj-all-reviews__summary{margin-bottom:14px}.hj-all-reviews__list{gap:10px}.hj-all-reviews__card{padding:16px!important}.hj-all-reviews__meta{margin:5px 0 8px}.hj-reviews-page{padding-top:14px!important}';
      doc.head.append(style);
      const productTitle=new URL(doc.baseURI).searchParams.get('title');
      const titleEl=doc.querySelector('[data-hj-all-reviews] [data-title]');
      if(productTitle&&titleEl)titleEl.textContent=productTitle;
      doc.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;const url=reviewURL(link.href);if(url){event.preventDefault();loadReviews(url);}});
      doc.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();dismiss();}});
      clearTimeout(timer);fallback.hidden=true;frame.hidden=false;
      const status=doc.querySelector('[data-hj-all-reviews] [data-status]');
      const ready=()=>{if(!status||status.hidden||!status.textContent.includes('Loading')){loading.hidden=true;return true;}return false;};
      if(!ready()){const observer=new MutationObserver(()=>{if(ready())observer.disconnect();});observer.observe(status,{attributes:true,childList:true,subtree:true});}
    }catch(error){loading.hidden=true;fallback.hidden=false;}
  });
  document.addEventListener('click',event=>{
    if(event.defaultPrevented||event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    const link=event.target.closest('a[href]');
    if(!link||link.hasAttribute('download')||dialog.contains(link))return;
    const url=reviewURL(link.href);if(!url)return;
    event.preventDefault();openReviews(url,link);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
